
export let ML_LOG_DEV = "MlInfo";
export let ML_LOG_INFO = "MlInfo";
export let ML_LOG_ERROR = "MlError";
export let ML_LOG_ENV = "MlEnvironment";


class MLLogChannel {

    public muted = false;

    constructor(private name: string) { }

    public log(message: string) {
        if (this.muted) {
            return;
        }
        console.log(this.name + "::" + message);
    }

    public logObj(message: string, object: any) {
        if (this.muted) {
            return;
        }
        //console.log({ l: this.name + "::" + message, element: object });
        console.log(this.name + "::" + message, object);
    }
}

export class MLLog {
    static #instance: MLLog;
    private constructor() { }

    private static get instance(): MLLog {
        if (!MLLog.#instance) {
            MLLog.#instance = new MLLog();
        }

        return MLLog.#instance;
    }

    private muted = false;
    private elements: Map<string, MLLogChannel> | null = null;

    private getChannel(channel: string): MLLogChannel {
        if (this.elements == null) {
            this.elements = new Map<string, MLLogChannel>();
        }
        if (!this.elements.has(channel)) {
            let newChannel = new MLLogChannel(channel);
            this.elements.set(channel, newChannel)
            return newChannel;
        } else {
            return this.elements.get(channel) as MLLogChannel;
        }
    }

    //Public Interface
    public static mute(muting = true) {
        let instance = MLLog.instance;
        instance.muted = muting;
    }

    public static muteChannel() {
        let instance = MLLog.instance;
        instance.muted = true;
    }

    public static log(channel: string, message: string, object?: any, trace: boolean = false) {
        let instance = MLLog.instance;
        if (!instance.muted) {
            let logChannel = instance.getChannel(channel);
            if (object === undefined) {
                logChannel.log(message);
            } else {
                logChannel.logObj(message, object);
            }
            if (trace) {
                console.trace();
            }
        }
    }

    public static logEnv(message: string, object?: any) {
        MLLog.log(ML_LOG_ENV, message, object)
    }

    public static logInfo(message: string, object?: any) {
        MLLog.log(ML_LOG_DEV, message, object)
    }

    public static logDev(message: string, object?: any, trace: boolean = false) {
        MLLog.log(ML_LOG_DEV, message, object, trace)
    }

    public static logError(message: string, object?: any, trace: boolean = false) {
        MLLog.log(ML_LOG_ERROR, message, object, trace)
    }
}